import styles from "./SuccessfullyRenewalModal.module.scss";
import close from "../../../assets/icons/close.svg";
import Button from "../../button/Button";
import { useTranslation } from "react-i18next";
import { subscriptionData } from "../../../types/details-api-types";
import { formatPriceWithCurrency } from "../../../utils";
import { useEffect } from "react";

interface SuccessfullyRenewalModalProps {
  setIsModalPauseConfirmVisible: (arg: boolean) => void;
  refreshData: () => void;
  data: subscriptionData
}

const SuccessfullyRenewalModal: React.FC<SuccessfullyRenewalModalProps> = ({
  setIsModalPauseConfirmVisible,
  refreshData,
  data
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    refreshData();
    // eslint-disable-next-line
  }, [])
  return (
    <div className={styles.root}>
      <div className={styles.root_header}>
        <p className={styles.root_header_title}>
          {t("Ready to Reactivate Your Subscription")}
        </p>
        <div className={styles.root_header_imgBlock}>
          <img
            className={styles.root_header_img}
            src={close}
            alt="close"
            onClick={() => setIsModalPauseConfirmVisible(false)}
          />
        </div>
      </div>
      <p className={styles.root_subtitle}>
        {t("Welcome back! Your Fortect subscription has been reactivated, and your next renewal will be on")}{" "}
        <span className={styles.root_message_data}>{new Date(data.next_payment).toLocaleDateString()}</span> {t("for")}{" "}
        <span className={styles.root_message_data}>{formatPriceWithCurrency(data.renewalPrice, data.renewalPriceCurrency!)}</span>.
      </p>
      <p className={styles.root_message}>
        {t("You can now enjoy uninterrupted access to all features. We've sent a confirmation email to your registered email address.")}
      </p>
      <div className={styles.root_button}>
        <Button
          onClick={() => setIsModalPauseConfirmVisible(false)}
          text={t("Return to Account")}
          classNames={styles.root_btn}
        />
      </div>
    </div>
  );
};

export default SuccessfullyRenewalModal;
